import React, { useEffect, useState } from 'react';
import { CHAINS } from '../../constants';
import { useGlobalState } from '../../state/GlobalStateProvider';
import Logo from '../Logo/Logo';

const ProjectTag = ({ project }) => {
  const [projectData, setProjectData] = useState();
  const [{ protocolMapping }] = useGlobalState();

  useEffect(() => {
    if (String(project).startsWith('chain')) {
      const chainId = Number(String(project).split('-')?.[1]);
      setProjectData(CHAINS[chainId]);
    } else {
      setProjectData(protocolMapping[project]);
    }
  }, [project, protocolMapping]);
  return <Logo src={projectData?.logo} width={'1rem'} height={'1rem'} borderRadius='0.25rem' />;
};

export default ProjectTag;
